export default __webpack_public_path__ + "static/media/export.09999635.svg";